<template>
	<div class="row center">
		<div v-if="topTitle" class="row between topSchool">
			<div class="school title">{{topTitleText || school.name}}</div>
			<div class="col d-flex align-items-end mr-2">
				<filter-dropdown/>
			</div>
			<filter-dropdown-visits/>
		</div>
		<div v-else class="row between topSchool">
			<div v-if="categoryId" :class="`summaryTag cat${categoryId}`">
				<h1>{{title}}
					<span v-show="academicLevelTitle" class="summaryTeachername">
					{{academicLevelTitle}}
					</span>
				</h1>
			</div>
			<h1 v-else>{{title}}
				<span v-show="academicLevelTitle" class="summaryTeachername">
					{{academicLevelTitle}}
				</span>
			</h1>
			<div class="average" v-if="percentageTitle">
				<em>{{parseInt(percentage)}}% <i>?</i></em>
				<span>{{percentageTitle}}</span>
			</div>
		</div>
		<div class="row">
			<hr>
		</div>
	</div>
</template>

<script>
export default {
	props: ['title', 'percentageTitle', 'percentage', 'topTitle', 'categoryId', 'academicLevelTitle', 'topTitleText'],
	computed: {
		school () {
			return this.$store.state.persistent.school;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";
.summary {
	&Kind {
		height: 6rem;
		&>h1 {
			font-size: $regularTitle;
			font-weight: 700;
			color: $semiBlack;
			position: relative;
		}
	}
	&Teachername {
		background-color: $odd;
		border-radius: 5rem;
		padding: 0.5rem 1rem;
		display: flex;
		flex-direction: column;
		font-size: $smallSize;
		color: $oxfordBlue;
		font-weight: 400;
		position: absolute;
		right: -10rem;
		top: 0.3rem;
	}
	&Tag {
		border-radius: 2rem;
		padding: 0.4rem 1rem;
		&.cat1 {
			background-color: $cat1;
		}
		&.cat2 {
			background-color: $cat2;
		}
		&.cat3 {
			background-color: $cat3;
		}
		&.cat4 {
			background-color: $cat4;
		}
		&>h1 {
			font-size: $regularTitle;
			color: $blank;
			font-weight: 400;
		}
	}
}

.topSchool {
	flex: 0 0 auto;
	height: 7rem;
	min-height: 100%;
	& > h1 {
		font-size: $regularTitle;
		font-weight: 700;
		color: $semiBlack;
		width: auto;
		position: relative;
	}
}

.average {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 13.2rem;
	& em {
		font-size: $regularTitle;
		color: $accentBlue;
		text-align: left;
		text-indent: 0.6rem;
		font-style: normal;
		& > i {
			background-color: $dawnBlue;
			border-radius: 2rem;
			padding: 0;
			font-size: 1.2rem;
			font-style: normal;
			color: $blank;
			text-align: center;
			line-height: 1.6rem;
			text-indent: 0;
			width: 1.5rem;
			height: 1.5rem;
			position: absolute;
			top: 1.7rem;
			right: 2rem;
			&:hover {
				background-color: $silkBlue;
				cursor: pointer;
			}
		}
	}
	& span {
		font-size: $smallSize;
		color: $semiBlack;
		text-align: center;
		position: relative;
	}
}

.school {
	max-width: 80%;
	align-items: center;
	&.title {
		font-size: $bigTitle;;
		color: $semiBlack;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TitleBar.vue